import type { IconsProps } from '@makemydeal/dr-sales-checkin-types';
import React from 'react';
import { StyledChevronDownIcon } from './chevrondownicon.style';

export const ChevronDownIcon: React.FC<IconsProps> = () => (
    <StyledChevronDownIcon
        data-testid="plus-icon"
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.8983 0.632394C12.0339 0.738903 12.0339 0.95192 11.8983 1.08506L6.23049 6.65012C6.09489 6.78326 5.90506 6.78326 5.76947 6.65012L0.101695 1.08506C-0.0338982 0.95192 -0.0338982 0.738903 0.101695 0.632394C0.302913 0.424423 0.415728 0.307822 0.616947 0.0998517C0.75254 -0.0332839 0.969488 -0.0332839 1.07796 0.0998517L6.01354 4.91936L10.922 0.0998517C11.0305 -0.0332839 11.2474 -0.0332839 11.383 0.0998517C11.5842 0.307822 11.697 0.424423 11.8983 0.632394Z"
            fill="white"
        />
    </StyledChevronDownIcon>
);
